import Vue from "vue";

import LoadingIcon from "./components/LoadingIcon";

Vue.component("loading-icon", LoadingIcon);
